import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import get from 'lodash/get';
import { getDeviceType, serviceErrorToAnalyticsFormat, getVersion } from './DigitalAnalyticsHelper';
import { processAnalyticsData } from '../common/aggregators/cancelOrderAgregator';

const configSourceToPageMap = {
    // source : pageName
    details: 'order details',
    orderlist: 'order history',
};

export class CanderOrderActionFilter extends BaseActionFilter {
    getPageNameBySource = (source) => {
        return configSourceToPageMap[source] || '';
    };

    getCancelOrderFormErrorDL(store, { error } = {}) {
        const getCancelOrderFormErrorDL = this.getFormErrorDL(serviceErrorToAnalyticsFormat(error));
        const orderCancelTime = this.getOrderCancelTime(store);
        const page = {
            pageInfo: {
                orderCancelTime,
            },
        };
        return {
            ...getCancelOrderFormErrorDL,
            page,
        };
    }

    cancelOrderSliderDL(store, payload = {}) {
        const { context } = store.getState();

        const deviceType = getDeviceType(context);

        const {
            data: { product = {}, transaction = {}, couponRewardsInfo = [] } = {},
            source,
            error,
        } = payload;

        const getCanceOrderSliderDL = this.updateCommonDigitalData();
        getCanceOrderSliderDL.cart.couponRewardsInfo = couponRewardsInfo;
        getCanceOrderSliderDL.page.pageInfo.pageName = 'cancel order slider'; // this.getPageNameBySource(source);
        getCanceOrderSliderDL.page.pageInfo.pageType = 'account';
        getCanceOrderSliderDL.page.pageInfo.siteSection = this.getPageNameBySource(source);
        getCanceOrderSliderDL.page.pageInfo.deviceType = deviceType;
        getCanceOrderSliderDL.page.pageInfo.searchRedirect = '';
        getCanceOrderSliderDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getCanceOrderSliderDL.page.pageInfo.version = getVersion('yoda post-purchase');
        getCanceOrderSliderDL.page.category = {};
        getCanceOrderSliderDL.page.category.primaryCategory = 'account';
        getCanceOrderSliderDL.page.category.subCategory1 = '';
        getCanceOrderSliderDL.page.category.subCategory2 = '';
        getCanceOrderSliderDL.page.category.department = 'account';
        getCanceOrderSliderDL.error = serviceErrorToAnalyticsFormat(error);

        // Cancel Slider data
        getCanceOrderSliderDL.product = product;
        getCanceOrderSliderDL.transaction = transaction;

        // console.log('slider page load data', { product, transaction });
        return getCanceOrderSliderDL;
    }

    getOrderCancelTime = (store) => {
        const state = store && store.getState && store.getState();
        return get(state, 'cancelOrderDetails.orderCancelTime', '0');
    };

    submitCancelOrderDL(store, { sliderData, submittedForm } = {}) {
        const orderCancelTime = this.getOrderCancelTime(store);
        // console.log('sliderAnalyticsData', sliderData, submittedForm, orderCancelTime);
        const getSubmitCanceOrderDL = processAnalyticsData(sliderData, submittedForm);
        getSubmitCanceOrderDL.page = {
            pageInfo: {
                orderCancelTime,
            },
        };
        return getSubmitCanceOrderDL;
    }
}

export default CanderOrderActionFilter;
